// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__abeAb","col":"Table_col__grrPZ","fulfillmentStatus":"Table_fulfillmentStatus__2ZHJA","emailCol":"Table_emailCol__1FDi-"};